import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=0af60d22&scoped=true&"
import script from "./navbar.vue?vue&type=script&lang=ts&"
export * from "./navbar.vue?vue&type=script&lang=ts&"
import style0 from "./navbar.vue?vue&type=style&index=0&id=0af60d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af60d22",
  null
  
)

export default component.exports